import { z } from "zod";
import { isBlockedHostname, isBlockedIpv6, isPrivateOrReservedIpv4, } from "./ip-address-policy.js";
export const SsrfValidationOkSchema = z
    .object({
    ok: z.literal(true),
    normalizedUrl: z.string().url(),
    hostname: z.string().min(1),
})
    .strict();
export const SsrfValidationFailSchema = z
    .object({
    ok: z.literal(false),
    reason: z.string().min(1),
})
    .strict();
/** Layer-1 URL validation — protocol/hostname literal guard before enqueue. Worker re-validates at DNS connection time. */
export function validatePublicScanUrl(rawUrl) {
    let parsed;
    try {
        parsed = new URL(rawUrl.trim());
    }
    catch {
        return { ok: false, reason: "invalid_url" };
    }
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
        return { ok: false, reason: "unsupported_protocol" };
    }
    if (parsed.username || parsed.password) {
        return { ok: false, reason: "credentials_not_allowed" };
    }
    const hostnameRaw = parsed.hostname.toLowerCase();
    if (!hostnameRaw) {
        return { ok: false, reason: "missing_hostname" };
    }
    const hostname = hostnameRaw.startsWith("[") && hostnameRaw.endsWith("]")
        ? hostnameRaw.slice(1, -1)
        : hostnameRaw;
    if (isBlockedHostname(hostname)) {
        return { ok: false, reason: "blocked_host" };
    }
    if (isPrivateOrReservedIpv4(hostname)) {
        return { ok: false, reason: "private_host" };
    }
    if (hostname.includes(":") && isBlockedIpv6(hostname)) {
        return { ok: false, reason: "private_host" };
    }
    parsed.hash = "";
    return {
        ok: true,
        normalizedUrl: parsed.toString(),
        hostname: hostnameRaw,
    };
}
export { assertResolvedIpAddressesSafe, classifyResolvedIpAddress, normalizeIpAddress, } from "./ip-address-policy.js";
//# sourceMappingURL=ssrf-validation.js.map